import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import InputMask from 'react-input-mask';
import { NumericFormat } from 'react-number-format';
import 'react-toastify/dist/ReactToastify.css';
import CashInService from '../../../services/Celcoin/immediateCashInService';
import { getTranslations } from '../../../services/languageUtils';

const BillPayment = () => {
  const [translations, setTranslations] = useState({});
  const [loading, setLoading] = useState(false);

  const [payer, setPayer] = useState({
    cpf_cnpj: '',
    name: '',
    email: ''
  });

  const [item, setItem] = useState({
    description: '',
    price_cents: ''
  });

  const [response, setResponse] = useState(null);

  useEffect(() => {
    const loadTranslations = async () => {
      const trans = await getTranslations(localStorage.getItem('language') || 'pt');
      setTranslations(trans);
    };
    loadTranslations();
  }, []);

  const handleGenerateBill = async () => {
    if (!payer.cpf_cnpj || !payer.name || !payer.email || !item.description || !item.price_cents) {
      toast.error('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    setLoading(true);

    try {
      const res = await CashInService.bill({
        payer: {
          cpf_cnpj: payer.cpf_cnpj,
          name: payer.name,
          email: payer.email
        },
        items: [
          {
            description: item.description,
            quantity: 1,
            price_cents: parseInt(item.price_cents)
          }
        ],
        method: "bank_slip"
      });

      if (res?.data?.identification) {
        setResponse(res.data);
        toast.success('Boleto gerado com sucesso!');
      } else {
        toast.error('Erro ao gerar boleto.');
      }
    } catch (err) {
      console.error(err);
      toast.error('Erro ao processar boleto.');
    } finally {
      setLoading(false);
    }
  };

  const handleCopyIdentification = async () => {
    try {
      await navigator.clipboard.writeText(response.identification);
      toast.success('Linha digitável copiada!');
    } catch {
      toast.error('Erro ao copiar linha digitável.');
    }
  };

  const handleOpenBoleto = () => {
    if (response?.bank_slip_pdf_url) {
      window.open(response.bank_slip_pdf_url, '_blank');
    }
  };

  const handleNewBill = () => {
    setResponse(null);
    setItem({ description: '', price_cents: '' });
  };

  return (
    <section className="pixTransferComponent">
      <span className="desktop">
        <div className="mainContent" style={{ paddingLeft: "15px" }}>
          <br />

          {/* === SE NÃO EXISTE BOLETO GERADO === */}
          {!response && (
            <>
              <p className="pLabel" style={{ marginBottom: "15px", fontWeight: "bolder" }}>
                Dados do pagador
              </p>

              <InputMask
                mask="999.999.999-99"
                className="input"
                placeholder="CPF ou CNPJ"
                value={payer.cpf_cnpj}
                style={{ marginBottom: "10px", padding: "5px" }}
                onChange={(e) => setPayer({ ...payer, cpf_cnpj: e.target.value })}
              />

              <input
                type="text"
                className="input"
                placeholder="Nome completo"
                value={payer.name}
                style={{ marginBottom: "10px", padding: "5px" }}
                onChange={(e) => setPayer({ ...payer, name: e.target.value })}
              />

              <input
                type="email"
                className="input"
                placeholder="E-mail"
                value={payer.email}
                style={{ marginBottom: "10px", padding: "5px" }}
                onChange={(e) => setPayer({ ...payer, email: e.target.value })}
              />

              <p className="pLabel" style={{ marginTop: "15px", marginBottom: "15px", fontWeight: "bolder" }}>
                Dados do boleto
              </p>

              <input
                type="text"
                className="input"
                placeholder="Descrição do pagamento"
                value={item.description}
                style={{ marginBottom: "10px", padding: "5px" }}
                onChange={(e) => setItem({ ...item, description: e.target.value })}
              />

              <NumericFormat
                className="input"
                placeholder="Valor (em reais)"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale
                prefix="R$ "
                style={{ marginBottom: "10px", padding: "5px" }}
                value={item.price_cents ? (item.price_cents / 100).toFixed(2) : ''}
                onValueChange={(values) => {
                  const { floatValue } = values;
                  setItem({ ...item, price_cents: floatValue ? floatValue * 100 : '' });
                }}
              />

              <div
                className={`buttonSend ${loading ? 'disabled' : ''}`}
                onClick={!loading ? handleGenerateBill : null}
                style={{ marginTop: "20px" }}
              >
                {loading ? <div className="loader"></div> : 'Gerar Boleto'}
              </div>
            </>
          )}

          {/* === SE BOLETO JÁ FOI GERADO === */}
          {response && (
            <>
              <p className="pLabel" style={{ marginBottom: "10px", fontWeight: "bolder" }}>
                Boleto gerado com sucesso
              </p>

              <div className="input" style={{ marginBottom: "10px" }}>
                {response.identification}
              </div>

              <div className="buttonSend" onClick={handleCopyIdentification}>
                Copiar linha digitável
              </div>

              <div className="buttonSend" style={{ marginTop: "10px" }} onClick={handleOpenBoleto}>
                Abrir boleto em nova aba
              </div>

              <div className="buttonSend" style={{ marginTop: "10px" }} onClick={handleNewBill}>
                Gerar novo boleto
              </div>
            </>
          )}
        </div>
      </span>

      <ToastContainer />
    </section>
  );
};

export default BillPayment;
